import React from 'react';

const StepperHeader = ( { text } ) => {
    return (
        <header className="finder-header mb-2">
            <h2 className="heading-widget h2 mb-0 font-weight-light text-inherit text-center heading-default">{text}</h2>
        </header>
    )
}

export default StepperHeader
